import {
    CONVERT_FILE_STAND_ALONE_URL,
    DOWNLOAD_TRANSFORMED_FILE_URL,
    getCsvTablePreviewUrl,
    getUploadFileOnServerUrl,
} from '../../../constants/urls';
import {allRequest, postRequest, REQUEST_METHOD_POST} from '../../../middlewares/api/actions';

export const PLUGINS_FILES_SUBMIT = 'PLUGINS_FILES_SUBMIT';
export const PLUGINS_CONVERT_SUBMIT = 'PLUGINS_CONVERT_SUBMIT';
export const CONVERTED_PLUGIN_FILE_DOWNLOAD = 'CONVERTED_PLUGIN_FILE_DOWNLOAD';
export const PLUGIN_FORM_CHANGE = 'PLUGIN_FORM_CHANGE';
export const PLUGIN_FORM_ERASE = 'PLUGIN_FORM_ERASE';
export const PLUGINS_GET_CSV_PREVIEW = 'PLUGINS_GET_CSV_PREVIEW';
export const PLUGINS_WIZARD_CSV_ROW_LIST_CSV_ROWS_GET = 'PLUGINS_WIZARD_CSV_ROW_LIST_CSV_ROWS_GET';

export const submitPluginInputFiles = (pluginUid, file, transformFile, processFile, action = PLUGINS_FILES_SUBMIT, cubeId = null) => {

    let fileFormData = new FormData();
    fileFormData.append('file', file);

    let transformFileFormData = new FormData();
    if (transformFile) transformFileFormData.append('file', transformFile);

    let processFileFormData = new FormData();
    if (processFile) processFileFormData.append('file', processFile);

    const areAllConfigFilesPresent = transformFile && processFile;
    const isAtLeastOneConfigFilePresent = transformFile || processFile;

    if (isAtLeastOneConfigFilePresent) {
        return allRequest(
            action,
            areAllConfigFilesPresent ? [REQUEST_METHOD_POST, REQUEST_METHOD_POST, REQUEST_METHOD_POST] : [REQUEST_METHOD_POST, REQUEST_METHOD_POST],
            areAllConfigFilesPresent ? [getUploadFileOnServerUrl(cubeId, pluginUid, "input"), getUploadFileOnServerUrl(cubeId, pluginUid, "transform"), getUploadFileOnServerUrl(cubeId, pluginUid, "process")] :
                [getUploadFileOnServerUrl(cubeId, pluginUid, "input"), transformFile ? getUploadFileOnServerUrl(cubeId, pluginUid, "transform") : getUploadFileOnServerUrl(cubeId, pluginUid, "process")],
            areAllConfigFilesPresent ? [fileFormData, transformFileFormData, processFileFormData] :
                [fileFormData, transformFile ? transformFileFormData : processFileFormData],
            t => ({
                start: t('scenes.utilities.plugin.modal.input.messages.submit.start'),
                success: t("scenes.utilities.plugin.modal.input.messages.submit.success")
            }),
            null
        );
    } else {
        return postRequest(
            action,
            getUploadFileOnServerUrl(cubeId, pluginUid, "input"),
            fileFormData,
            t => ({
                start: t('scenes.utilities.plugin.modal.input.messages.submit.start'),
                success: t("scenes.utilities.plugin.modal.input.messages.submit.success")
            })
        );
    }
};

export const pluginFormErase = () => ({
    type: PLUGIN_FORM_ERASE
})

export const pluginFormChange = (fields) => ({
    type: PLUGIN_FORM_CHANGE,
    fields
});

export const submitPluginConvertAction = (pluginUid, fileServerPath, transformFileServerPath, processFileServerPath, lang, outputExtension, dllName, action = PLUGINS_CONVERT_SUBMIT, mode = 1, cubeId = 0) => postRequest(
    action,
    CONVERT_FILE_STAND_ALONE_URL,
    {PluginId: pluginUid, InputFilePath: fileServerPath, MappingPath: transformFileServerPath, ProcessPath: processFileServerPath, Lang: lang, OutputExtension: outputExtension, DllName: dllName, Mode: mode, IdCube: cubeId},
    t => ({
        start: t('scenes.utilities.plugin.modal.output.messages.conversion.start'),
        success: t("scenes.utilities.plugin.modal.output.messages.conversion.success")
    })
);

export const downloadConvertedPluginFile = fileName => ({
    ...postRequest(
        CONVERTED_PLUGIN_FILE_DOWNLOAD,
        DOWNLOAD_TRANSFORMED_FILE_URL,
        {fileName, mode: 1},
        undefined,
        undefined,
        true
    ),
    fileSave: {
        name: fileName
    }
});

export const getCSVPreview = (outputFilePath, csvPreviewParams) =>  postRequest(
    PLUGINS_GET_CSV_PREVIEW,
    getCsvTablePreviewUrl(
        csvPreviewParams.csvSeparator || ",",
        csvPreviewParams.csvDelimiter || null,
        csvPreviewParams.csvHasHeader || false,
        outputFilePath,
        null ,
        null,
        1
    ),
    {
        PageNum: 1,
        PageSize: 100,
        FilterTable: null,
        SortCols: null,
        SortByDesc: true,
    },
);

export const getPluginStandaloneWizardCsvRowListCsvRows = (pageNum, pageSize, filterTable, sortCols, sortByDesc, separator, delimiter, hasHeader, filePath, mode = null) => postRequest(
    PLUGINS_WIZARD_CSV_ROW_LIST_CSV_ROWS_GET,
    getCsvTablePreviewUrl(separator, delimiter, hasHeader, filePath, null, null, mode),
    {
        PageNum: pageNum,
        PageSize: pageSize,
        FilterTable: filterTable,
        SortCols: sortCols,
        SortByDesc: sortByDesc
    }
);